const Routes = {
  splash: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  home: '/home',
  taskTimesheetsPattern: '/tasks/:taskId',
  taskTimesheets: (taskId) => `/tasks/${taskId}`,
};

export default Routes;
